import { Trials } from "../components/trials/trials";

export function TrialsPage(): JSX.Element {
  return <Trials />;
}
